// 导入axios实例
import httpRequest from '@/request/index'

// 登录
export function login(data = {}) {
  return httpRequest({
    url: '/login',
    method: 'post',
    data,
  })
}
// 注册
export function register(data = {}) {
  return httpRequest({
    url: '/registerUser',
    method: 'post',
    data,
  })
}
// 获取用户列表
export function getUserList(params = {}) {
  return httpRequest({
    url: '/getUserList',
    method: 'get',
    params,
  })
}
// 获取用户信息
export function getUserInfo(params = {}) {
  return httpRequest({
    url: '/getUserInfo',
    method: 'get',
    params,
  })
}
// 修改用户密码
export function editPassword(data = {}) {
  return httpRequest({
    url: '/editPassword',
    method: 'post',
    data,
  })
}
// 重置用户密码
export function resetPassword(data = {}) {
  return httpRequest({
    url: '/resetPassword',
    method: 'post',
    data,
  })
}
// 修改用户详情-管理员
export function updateUser(data = {}) {
  return httpRequest({
    url: '/updateUser',
    method: 'post',
    data,
  })
}
// 修改用户名
export function editUserInfo(data = {}) {
  return httpRequest({
    url: '/editUserInfo',
    method: 'post',
    data,
  })
}
// 上下线用户
export function banUser(data = {}) {
  return httpRequest({
    url: '/banUser',
    method: 'post',
    data,
  })
}
// 删除用户
export function delUser(params = {}) {
  return httpRequest({
    url: '/delUser/' + params.id,
    method: 'delete',
  })
}


// 获取公园列表
export function aaa(params = {}) {
  return httpRequest({
    url: '/aaa',
    method: 'get',
    params,
  })
}
// 获取公园列表
export function bbb(data = {}) {
  return httpRequest({
    url: '/bbb',
    method: 'post',
    data,
  })
}
// 获取公园列表
export function getParkList(params = {}) {
  return httpRequest({
    url: '/getParkList',
    method: 'get',
    params,
  })
}
// 统计公园类型数量
export function getParkTypeStatistics(params = {}) {
  return httpRequest({
    url: '/getParkTypeStatistics',
    method: 'get',
    params,
  })
}
// 新增公园
export function addPark(data = {}) {
  return httpRequest({
    url: '/addPark',
    method: 'post',
    data,
  })
}
// 获取公园详情
export function getParkDetailById(params = {}) {
  return httpRequest({
    url: '/getParkDetailById',
    method: 'get',
    params,
  })
}
// 修改公园详情
export function updatePark(data = {}) {
  return httpRequest({
    url: '/updatePark',
    method: 'post',
    data,
  })
}
// 上下线公园
export function banPark(data = {}) {
  return httpRequest({
    url: '/banPark',
    method: 'post',
    data,
  })
}
// 删除公园
export function delPark(params = {}) {
  return httpRequest({
    url: '/delPark/' + params.park_id,
    method: 'delete',
  })
}


// 获取新闻类型列表
export function getNewsTypeList(params = {}) {
  return httpRequest({
    url: '/getNewsTypeList',
    method: 'get',
    params,
  })
}
// 新增新闻类型
export function addNewsType(data = {}) {
  return httpRequest({
    url: '/addNewsType',
    method: 'post',
    data,
  })
}
// 修改新闻类型
export function updateNewsType(data = {}) {
  return httpRequest({
    url: '/updateNewsType',
    method: 'post',
    data,
  })
}
// 上下线新闻类型
export function banNewsType(data = {}) {
  return httpRequest({
    url: '/banNewsType',
    method: 'post',
    data,
  })
}
// 获取新闻类型绑定的公园
export function getParkInfoByNewsType(params = {}) {
  return httpRequest({
    url: '/getParkInfoByNewsType',
    method: 'get',
    params,
  })
}
// 删除新闻类型
export function delNewsType(params = {}) {
  return httpRequest({
    url: '/delNewsType/' + params.id,
    method: 'delete',
  })
}
// 获取新闻列表
export function getNewslList(params = {}) {
  return httpRequest({
    url: '/getNewslList',
    method: 'get',
    params,
  })
}
// 获取新闻详情
export function getNewsDetailById(data = {}) {
  return httpRequest({
    url: '/getNewsDetailById',
    method: 'post',
    data,
  })
}
// 新增新闻
export function addNewsDetail(data = {}) {
  return httpRequest({
    url: '/addNewsDetail',
    method: 'post',
    data,
  })
}
// 修改新闻
export function updateNewsDetail(data = {}) {
  return httpRequest({
    url: '/updateNewsDetail',
    method: 'post',
    data,
  })
}
// 修改新闻-批量修改新闻类型
export function updateNewsTypeList(data = {}) {
  return httpRequest({
    url: '/updateNewsTypeList',
    method: 'post',
    data,
  })
}
// 删除新闻
export function delNewsDetail(data = {}) {
  return httpRequest({
    url: '/delNewsDetail/' + data.news_id,
    method: 'delete',
    data,
  })
}
// 上下线新闻
export function banNewsDetail(data = {}) {
  return httpRequest({
    url: '/banNewsDetail',
    method: 'post',
    data,
  })
}
// 上下线新闻-批量
export function banNewsDetailList(data = {}) {
  return httpRequest({
    url: '/banNewsDetailList',
    method: 'post',
    data,
  })
}



// 获取轮播图列表
export function getBannerListByParkId(params = {}) {
  return httpRequest({
    url: '/getBannerListByParkId',
    method: 'get',
    params,
  })
}
// 新增轮播图
export function addBanner(data = {}) {
  return httpRequest({
    url: '/addBanner',
    method: 'post',
    data,
  })
}
// 修改轮播图
export function updateBanner(data = {}) {
  return httpRequest({
    url: '/updateBanner',
    method: 'post',
    data,
  })
}
// 启禁用轮播图
export function banBanner(data = {}) {
  return httpRequest({
    url: '/banBanner',
    method: 'post',
    data,
  })
}
// 删除轮播图
export function delBanner(data = {}) {
  return httpRequest({
    url: '/delBanner/' + data.is_id,
    method: 'delete',
    data,
  })
}

// 上传文件
export function UploadFile(data = {}) {
  return httpRequest({
    url: '/Upload/UploadFile',
    method: 'post',
    data,
  })
}

// word转换为html
export function DocxToHTML(data = {}) {
  return httpRequest({
    url: '/Upload/DocxToHTML',
    method: 'post',
    data,
  })
}